module.exports = __webpack_public_path__ + "img/img5.207f6b52.jpg";